import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from 'react-redux';
import "./POI.css";
import { RootState } from "../../../redux/reducers/root";
import { getCurrentPropertyDetails } from "../../../redux/actions/currentPropertyDetails/currentPropertyDetails";
import { CityResponse } from "../../../redux/reducers/getNBHDReducer/getCityReducer";
import { searchCityCoords } from "../../../redux/actions/nbhd/search";
import POIListInfo from "../POIListInfo/POIList";
import {currencyFormat} from "../../../utils/helperFunction";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import { useMap } from "react-map-gl";
import { CurrentPropertyDetailsState } from "../../../redux/reducers/getCurrentPropertyDetailsReducer/currentPropertyDetailsReducer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";

export default function POI() {

    const {mainMap} = useMap();
    
    const currentProperty = useSelector((state: RootState) => state.propertyListReducer.currentProperty);
    const currentPropertyDetails = useSelector((state: RootState) => state.curPropertyDetailsReducer.currentPropertyDetails as CurrentPropertyDetailsState);
    const snapShotInfo = useSelector((state: RootState) => state.SnapShotReducer.snapShotInfo as getSnapShotState);

    const snapShotInfoData = snapShotInfo["snapShotInfo"]?.['data'];
    const currentSnapRoll = snapShotInfoData?.roll;

    const propertyDetails: Record<string, unknown> = currentPropertyDetails["propertyDetails"];

    const CityCoords = useSelector((state: RootState) => state.NBHDReducer.CityCoords as CityResponse);

    const currentPhysicalAddress: string = currentProperty["currentAddress"] as string;
    
    const currentRoll: string = currentProperty['currentProperty'] as string;

    const loading: boolean = currentPropertyDetails['loading'];

    const [poiMissingCoords, setPoiMissingCoords] = useState(false);
    
    const dispatch = useDispatch();
    
    const { t } = useTranslation("nbhd");

    const FindPropOnMap = () => {
        const centroid = propertyDetails["spatial"]["features"][0]["properties"]["centroid"];
        if (centroid){
             mainMap?.jumpTo({center:[centroid.lng,centroid.lat]}, {roll: propertyDetails["rollNumber"]});
        }
        else {
            // if no coords for property, get city coords
            const missingCoords:Array<string> = [];
            const cityFullName =  propertyDetails["propertyData"]["municipalityDescription"];
            if (cityFullName.includes('CITY OF')){
                missingCoords.push(cityFullName.replace('CITY OF ',''));
            } else if (cityFullName.includes('NORTH ')){
                missingCoords.push(cityFullName);
            } else if (cityFullName.includes('SOUTH ')){
                missingCoords.push(cityFullName);
            } else if (cityFullName.includes('st. ')){
                missingCoords.push(cityFullName);
            } else {
                missingCoords.push(cityFullName.substring(0, cityFullName.indexOf(' ')));
            }
            if (missingCoords.length > 0) {
                dispatch(searchCityCoords({cities:[...new Set(missingCoords)]}))
                setPoiMissingCoords(true)
            } else {
                setPoiMissingCoords(false)
            }
        }
    }

    useEffect(() =>{
        // after getting coords of cities:
        if (CityCoords["city_coords"] && poiMissingCoords) {
          mainMap?.jumpTo({ center: [CityCoords["city_coords"][0]["lng"], CityCoords["city_coords"][0]["lat"]] });
          mainMap?.setZoom(15);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
      }, [CityCoords]);

    useEffect(() => {
        if(!currentPropertyDetails["propertyDetails"] && currentRoll && !currentPropertyDetails.loading){
            dispatch(getCurrentPropertyDetails(currentRoll));
        }
    }, [currentRoll, dispatch, currentProperty, currentPropertyDetails]);

    const renderValue = () => {
        let salesValue = "";
        if (propertyDetails) {
            // const physicalAddress = propertyDetails["addressPhysical"] as Record<string, string | null>;
            const assessment = propertyDetails["assessment"] as Record<string, string | null>;
            if (assessment) {
                const addressValue = assessment["valueRounded"];
                if (addressValue) {
                    salesValue = currencyFormat(parseInt(addressValue));
                } else{
                    salesValue = "";
                }
            }
        }
        return<>{salesValue}</>
    }

    const renderInfo = () => {
        let retrunInfo = "";
        if (propertyDetails) {
            // const physicalAddress = propertyDetails["addressPhysical"] as Record<string, string | null>;
            const salesInfo = propertyDetails["sales"]as Record<string, string | null>;
            if (salesInfo) {
                if (salesInfo['date']){
                    retrunInfo = salesInfo['date'];
                } else {
                    retrunInfo = t("nbhd.POI.sales");
                }
            }
        }
        return<>{retrunInfo}</>
    }

    return (<>
    <div className="NBHD-first-row">
        <div className="NBHD-POI-tips">
            <p>{t("nbhd.POI.tips")}</p>
        </div>
        <AmpLoadingSpinner loading={loading}>
        <div className="row firstrow" key="-1">
            <div className={`favourites-row-content ${(currentSnapRoll === currentRoll) && "selected"}`} onClick={e => FindPropOnMap()}>
                <div className="favourites-row-image" >
                    <FontAwesomeIcon icon={faHouse} size="3x" color="#005ca6"/>
                </div>
                <div className="favourites-row-detail">
                    <p className="property-address blue text-uppercase">{currentPhysicalAddress}</p>
                    <p className="cva-container">
                        <span className="cva-header">CVA</span>
                        <span className="cva-value">{renderValue()}</span>
                    </p>
                    <p className="sale-container">
                        <span className="sale-header">{renderInfo()}</span>
                    </p>
                </div>
            </div>
        </div>
        </AmpLoadingSpinner>
        
    </div>
    <div>
        <POIListInfo />
    </div>
    
    
    </>);
}